export const title = "Recent Transactions";
export const empty = "None here";
export const done = "Done";
export const transaction = "Transaction";
export const peso = "PHP";
